// Редакции оферты и согласия на обработку ПДн, которые показывает этот бандл.
// Отдельно от текстов (lib/legal/*): этот модуль импортируют формы входа и окно
// согласия, а тексты в on-prem бандл попадать не должны
// (src/config/no-legal-in-onprem.test.js).
//
// Новая редакция документа — в одном коммите: текст в lib/legal/*Newton.js, эта
// константа и LEGAL_*_VERSION у bit-auth в docker-compose.yml и
// docker-compose.stand.yml. Расхождение ловит
// bit-auth/app/tests/test_legal_versions_consistency.py.
export const OFFER_VERSION = '2026-10-08';
export const CONSENT_VERSION = '2026-10-08';
